import React from "react";
import Story from "./Story";
import "./StoryReel.css";

function StoryReel() {
  return (
    <div className="storyReel">
      <Story
        image="https://images.ctfassets.net/az3stxsro5h5/Dnt0B90bCx0YkVLA6uQ0o/94cb5418fec59b28f206e67c7d46f3e1/https___later.com_blog_wp-content_uploads_2019_01_Facebook-Stories-exist-for-a-maximum-of-24-hours.png?w=450&h=800&q=50&fm=png"
        profileSrc="https://avatars.githubusercontent.com/u/59873975?v=4"
        title="Ritwik Shaw"
      />
      <Story
        image="https://images.unsplash.com/photo-1554774853-d50f9c681ae2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80"
        profileSrc="https://avatars.githubusercontent.com/u/24712956?v=4"
        title="Sonny "
      />
      <Story
        image="https://images.unsplash.com/photo-1500099817043-86d46000d58f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
        profileSrc="https://avatars.githubusercontent.com/u/83940432?v=4"
        title="Shamik Das"
      />
      <Story
        image="https://images.unsplash.com/photo-1500462918059-b1a0cb512f1d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
        profileSrc="https://avatars.githubusercontent.com/u/54466041?v=4"
        title="Samriddhi"
      />
      <Story
        image="https://images.unsplash.com/photo-1623939012339-5b3dc8eca7c6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80"
        profileSrc="https://media-exp1.licdn.com/dms/image/C5603AQGbYatDSb6zww/profile-displayphoto-shrink_400_400/0/1651552899629?e=1660176000&v=beta&t=QYGEtMWaGlrlL-_yGhFLSEIx9YP6UkHd9o4jYW1ayWY"
        title="Bidipta"
      />
    </div>
  );
}

export default StoryReel;
